export default [
  { value: '30', label: 'Factura', param: '' },
  { value: '32', label: 'Factura Exenta', param: '' },
  { value: '33', label: 'Factura Electrónica', param: 'facturaAfecta' },
  { value: '34', label: 'Factura Electrónica Exenta', param: 'facturaExenta' },
  { value: '110', label: 'Factura de Exportación', param: 'exportacion' },
  { value: '45', label: 'Factura de Compra', param: '' },
  { value: '46', label: 'Factura Electrónica de Compra', param: 'compra' },
  { value: '43', label: 'Liquidación de Factura', param: 'liquidacionFactura' },
  { value: '50', label: 'Guía de Despacho', param: '' },
  { value: '52', label: 'Guía Electrónica de Despacho', param: 'guiaDespacho' },
  { value: '60', label: 'Nota Crédito', param: '' },
  { value: '61', label: 'Nota Electrónica de Crédito', param: 'notaCredito' },
  { value: '112', label: 'Nota Crédito de Exportación', param: 'notaCreditoExportacion' },
  { value: '55', label: 'Nota Débito', param: '' },
  { value: '56', label: 'Nota Electrónica de Débito', param: 'notaDebito' },
  { value: '111', label: 'Nota Débito de Exportación', param: 'notaDebitoExportacion' },
  { value: '35', label: 'Boleta', param: '' },
  { value: '38', label: 'Boleta Exenta', param: '' },
  { value: '39', label: 'Boleta Electrónica', param: 'boleta' },
  { value: '41', label: 'Boleta Electrónica Exenta', param: 'boletaExenta' },
  { value: 'HES', label: 'HES - Hoja Entrada Servicio', param: '' },
  { value: 'HEM', label: 'HEM - Hoja Entrada Mercaderia', param: '' },
  { value: 'SCO', label: 'SCO - Solicitud de Compra', param: '' },
  { value: 'MP', label: 'MP - Mercado Público', param: '' },
  { value: '801', label: 'Orden de Compra', param: '' },
  { value: '802', label: 'Nota de Pedido', param: '' },
  { value: '803', label: 'Contrato', param: '' },
  { value: '804', label: 'Resolución', param: '' },
  { value: '805', label: 'Proceso Chile Compra', param: '' },
  { value: '806', label: 'Ficha Chile Compra', param: '' },
  { value: '807', label: 'DUS', param: '' },
  { value: '808', label: 'B/L Conocimiento de Embarque', param: '' },
  { value: '809', label: 'AWB', param: '' },
  { value: '810', label: 'MIC/DATA', param: '' },
  { value: '811', label: 'Carta de Porte', param: '' },
  { value: '812', label: 'Res. SNA Servicio Exportación', param: '' },
  { value: '813', label: 'Pasaporte', param: '' },
  { value: '814', label: 'Cert. Depósito BP', param: '' },
  { value: '815', label: 'Vale Prenda BP', param: '' },
  { value: 'NV', label: 'Nota de Venta', param: '' },
  { value: 'FIN', label: 'Factura Interna', param: '' },
  { value: '-1', label: 'Centro de Costo', param: '' },
  { value: 'RD1', label: 'Rendición de Financiamiento', param: '' },
  { value: 'RD2', label: 'Rendición de Gastos', param: '' },
  { value: 'RD3', label: 'Rendición de Fondos', param: '' },
  { value: 'LIC', label: 'Licitación', param: '' },
  { value: '99', label: 'Anticipos y otras Transacciones', param: '' },
  { value: 'BGT', label: 'Boleta de Garantía', param: '' },
  { value: 'PLZ', label: 'Póliza', param: '' },
  { value: 'SWF', label: 'Swift', param: '' },
  { value: 'PGR', label: 'Pagare', param: '' },
  { value: 'VLV', label: 'Vale Vista', param: '' },
  { value: 'CHI', label: 'Cheque Internacional', param: '' },
  { value: 'CHN', label: 'Cheque Nacional', param: '' },
  { value: 'EPG', label: 'Estado de Pago', param: '' },
  { value: 'PRY', label: 'Proyecto', param: '' },
  { value: 'CFZ', label: 'Certificado de Fianza', param: '' },
  { value: 'ARCHIVO', label: 'Archivo', param: '' },
  { value: 'MP', label: 'Orden de Compra Mercado Público', param: '' },
  { value: 'ADJ', label: 'Adjudicación', param: '' },
  { value: 'NPP', label: 'Nómina Pronto Pago', param: '' },
  { value: 'APR', label: 'Expediente', param: '' },
  { value: '66', label: 'Boleta Honorarios Electrónica', param: '' },
  { value: 'DDPP', label: 'Documentos Personalizados', param: '' },
  { value: 'DTP', label: 'Documento de pago', param: '' },
  { value: '0', label: 'Otros', param: '' },
  { value: '821', label: 'Geo Referencia Predio', param: '' },
  { value: '822', label: 'ROL Avalúa Predio', param: '' },
  { value: '823', label: 'Plan Manejo - CONAF', param: '' },
  { value: 'UDP', label: 'Unidad de pago (MOP)', param: '' }
];
